var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmelt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41022 250.363C5.41022 115.589 114.666 6.33356 249.44 6.33356C384.213 6.33356 493.469 115.589 493.469 250.363C493.469 385.137 384.213 494.392 249.44 494.392C114.666 494.392 5.41022 385.137 5.41022 250.363Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#aa7d50",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.636 120.576L281.663 138.263L181.254 195.474L203.16 209.759L305.064 150.304L368.94 188.332L368.94 203.909L253.636 271.392L225.948 253.501L326.016 196.019L302.343 182.48L202.275 241.936L137.922 203.501L137.922 188.332L253.636 120.576Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.077 333.976L204.044 350.03L137.922 312.957L137.922 220.917L253.636 288.399L368.94 220.917L368.94 312.48L253.43 379.078L226.425 362.141L339.008 297.311L339.008 271.392L253.636 319.691L167.853 271.392L167.853 297.311L229.077 333.976Z",
    fill: "#a6a8ab",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmelt);
export default __webpack_public_path__ + "static/media/smelt.d3b8610c36af0380637d3919c21dad34.svg";
export { ForwardRef as ReactComponent };